import { Pagination, VehicleData } from "../types";

export interface FavouritesServiceResponse extends Response {
  data?: VehicleData[];
  meta?: {
    id: {
      ulid: string
    },
    pagination: Pagination
  }
}

class FavouritesService {

  constructor(
    public globalApi: string,
    public ulid: string | undefined,
  ) {}

  request = async (vins?: string[] | null) => {
    const ulid = this.ulid;
    const endpoint = this.globalApi + '/inventory-app/favourites';
    const url = new URL(endpoint);
    const params = new URLSearchParams();
    if (ulid) {
      params.append('id', ulid);
    }

    if (vins?.length) {
      params.append('vins', vins!.toString());
    }

    url.search = params.toString();

    const response = await this.fetch(url);

    if (this.ulid == undefined && response && response.meta?.id.ulid) {
      this.ulid = response.meta?.id.ulid;
    }

    return response;
  }

  fetch = (fetchInfo: URL) : Promise<FavouritesServiceResponse> => {
    return new Promise((resolve, reject) => {

      let response: Response;

      fetch(fetchInfo)
        .then(res => {
          response = res;
          return res.json();
        })
        .then(body => {
          if (response.ok) {
            response = body;
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export default FavouritesService;
